var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-tabs',{staticClass:"my-3",attrs:{"pills":""},scopedSlots:_vm._u([{key:"tabs-end",fn:function(){return _vm._l((_vm.tabs),function(tab){return _c('b-nav-item',{key:tab.route,attrs:{"to":{ name: tab.route },"active":tab.active}},[_vm._v(" "+_vm._s(tab.label)+" ")])})},proxy:true}])}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }